import { createFileRoute } from '@tanstack/react-router'
import { WorldcupResearchRouteKernel, worldcupResearchRouteKernel } from '~/features/research-workspace/route-kernels'

export const Route = createFileRoute('/research/worldcup')({
  ...worldcupResearchRouteKernel,
  component: WorldcupResearchRoute,
})

function WorldcupResearchRoute() {
  return <WorldcupResearchRouteKernel route={Route} />
}
